import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const virtualAgentConversationsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtual-agent-conversations',
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations',
	exact: true,
};
